import { RepositionDurationResponse } from '@interfaces/reposition-duration-response.interface';
import { DirectionEnum } from '../../../../v2/dashboard-home/enums/direction.enum';

/**
 * Normalizes API reposition duration response so every field is present.
 *
 * @param response - raw reposition duration API response
 */
export function normalizeRepositionDurationResponse(
  response: Partial<RepositionDurationResponse> | null | undefined,
): RepositionDurationResponse {
  return {
    outboundDurationMinutes: toNullableMinutes(response?.outboundDurationMinutes),
    inboundDurationMinutes: toNullableMinutes(response?.inboundDurationMinutes),
  };
}

/**
 * Resolves duration minutes from the API response for the given direction.
 *
 * @param direction - outbound or inbound reposition flow
 * @param response - reposition duration API response
 */
export function getRepositionDurationMinutes(direction: DirectionEnum, response: RepositionDurationResponse): number | null {
  const normalizedResponse: RepositionDurationResponse = normalizeRepositionDurationResponse(response);
  const minutes: number | null =
    direction === DirectionEnum.Outbound ? normalizedResponse.outboundDurationMinutes : normalizedResponse.inboundDurationMinutes;

  return minutes;
}

/**
 * Converts a raw minute value to a finite minute count or null.
 *
 * @param value - raw minute value from API
 */
function toNullableMinutes(value: number | null | undefined): number | null {
  if (value == null || !Number.isFinite(Number(value))) {
    return null;
  }

  return Math.floor(Number(value));
}
